import CheckInIndexVue from "@/views/check-in/CheckInIndex.vue";

const checkin = [
    {
        path: '/checkin',
        name: 'checkin',
        component: CheckInIndexVue
    }
]

export default checkin;